import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import { parseJwt } from '@/utils/jwtUtils'
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()
// const decode = () => {
//   const token = getToken()
//   const user = parseJwt(token)
// }

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const { data } = response
        if (response.code === 1) {
          const info = parseJwt(data)
          const roleId = JSON.parse(info.userInfo).roleId
          if (roleId === 1) {
            window.localStorage.setItem('roles', 'student')
          } else if (roleId === 2) {
            window.localStorage.setItem('roles', 'teacher')
          } else if (roleId === 3) {
            window.localStorage.setItem('roles', 'admin')
          } else if (roleId === 4) {
            window.localStorage.setItem('roles', 'mteacher')
          } else if (roleId === 5) {
            window.localStorage.setItem('roles', 'parent')
          } else if (roleId === 6) {
            window.localStorage.setItem('roles', 'organization')
          }

          // 保存用户信息到 localStorage
          const parsedUserInfo = JSON.parse(info.userInfo)
          window.localStorage.setItem('userInfo', JSON.stringify({
            id: parsedUserInfo.id,
            roleId: parsedUserInfo.roleId,
            data: parsedUserInfo,
            mark: parsedUserInfo.mark || 0
          }))

          commit('SET_TOKEN', data)
          setToken(data)
          resolve()
        } else {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          return reject(new Error('Verification failed, please Login again.'))
        }

        const { realName, avatar } = data

        commit('SET_NAME', realName)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        sessionStorage.clear()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
